/**
 * Подвал кабинета — короткая версия сайтового.
 *
 * Та же разметка и те же классы, но колонок меньше: кабинет — рабочий
 * инструмент, человек пришёл сюда делать дело, а не изучать платформу.
 * Нужное здесь — куда писать, если что-то сломалось, и чем регулируется то,
 * что партнёр публикует.
 */
import { Logo } from '@allswipes/ui';
import { Link } from 'react-router-dom';

const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'http://localhost:8080';
const APP_URL = import.meta.env.VITE_APP_URL ?? 'http://localhost:5173';

export function SiteFooter() {
  return (
    <footer className="sfoot">
      <div className="sfin">
        <div className="sfbrand">
          <Logo height={18} />
        </div>
        <p className="sftag">Кабинет партнёра — акции, призы и их экономика</p>

        <div className="sfcols">
          <div className="sfcol">
            <div className="sfh">Работа</div>
            <div className="sfl">
              <Link to="/campaigns">
                <span className="t">Акции</span>
                <span className="n">Статусы и копии</span>
              </Link>
              <Link to="/claims">
                <span className="t">Выдача призов</span>
                <span className="n">Очередь и статусы</span>
              </Link>
              <Link to="/reviews">
                <span className="t">Отзывы</span>
                <span className="n">Рейтинг бренда</span>
              </Link>
              <Link to="/audit">
                <span className="t">Аудит-журнал</span>
                <span className="n">Кто и что сделал</span>
              </Link>
            </div>
          </div>
          <div className="sfcol">
            <div className="sfh">Платформа</div>
            <div className="sfl">
              <a href={SITE_URL} target="_blank" rel="noreferrer">
                <span className="t">О проекте</span>
                <span className="n">Публичная страница</span>
              </a>
              <a href={APP_URL} target="_blank" rel="noreferrer">
                <span className="t">Приложение</span>
                <span className="n">Что видит участник</span>
              </a>
              <a href={`${SITE_URL}#fair`} target="_blank" rel="noreferrer">
                <span className="t">Честность</span>
                <span className="n">Как это проверяется</span>
              </a>
            </div>
          </div>
        </div>

        <div className="sfbot">
          <span>© {new Date().getFullYear()} ALLSWIPES</span>
          <span className="dot">·</span>
          <a href={`${SITE_URL}/terms`} target="_blank" rel="noreferrer">
            Условия использования
          </a>
          <span className="dot">·</span>
          <a href={`${SITE_URL}/privacy`} target="_blank" rel="noreferrer">
            Политика конфиденциальности
          </a>
          <span className="dot">·</span>
          <Link to="/brand">Профиль бренда</Link>
        </div>

        <p className="sfnote">
          Опубликованная акция — это обязательство перед участниками: правила подписаны хешем,
          механика и призы после запуска не меняются. Для изменений нужна копия акции.
        </p>
      </div>
    </footer>
  );
}
